import { combineReducers } from 'redux'

// Import RTK slices
import authenticateReducer from '../slices/authenticateSlice'
import userReducer from '../slices/userSlice'
import layoutReducer from '../slices/layoutSlice'
import formDataReducer from '../slices/formDataSlice'
import appDataReducer from '../slices/appDataSlice'
import modalReducer from '../slices/modalSlice'

export interface RootState {
  authenticate: ReturnType<typeof authenticateReducer>
  user: ReturnType<typeof userReducer>
  layout: ReturnType<typeof layoutReducer>
  formData: ReturnType<typeof formDataReducer>
  appData: ReturnType<typeof appDataReducer>
  modal: ReturnType<typeof modalReducer>
}

const rootReducer = combineReducers({
  authenticate: authenticateReducer,
  user: userReducer,
  layout: layoutReducer,
  formData: formDataReducer,
  appData: appDataReducer,
  modal: modalReducer,
})

export default rootReducer